import { createFileRoute } from "@tanstack/react-router";

import UsersAdmin from "@/components/UsersAdmin";

// Generated to match `src/app/admin/users/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/users")({
  component: UsersAdmin,
});
